import { Site } from '@envato/foundation-types'
import * as React from 'react'

import { config } from '../../common/config'
import ui from '../../common/constants/ui'
import crossSellLinksLayoutConfig from '../../config/layout/crossSellLinks'
import EnhancedLazyLoad from './enhancedLazyLoad'
import SafeInnerHtml from './safeInnerHtml'

const imageSrc = (path: string) => {
  return config.assets.PUBLIC_PATH + path
}

const imageSrcSet = (paths: string[]) => {
  return paths
    .map(path => {
      return imageSrc(path)
    })
    .join(', ')
}

const urlFor = (urlData: any, currentSite: Site) => {
  return ['base', 'path', 'params'].reduce((url, part) => {
    const selectedData = urlData[part][currentSite] || urlData[part].default

    if (part === 'params') {
      const serializedParams = Object.keys(selectedData)
        .reduce(
          (params, key) => {
            return params.concat(`${key}=${selectedData[key]}`)
          },
          [] as string[]
        )
        .join('&')
      url = `${url}?${serializedParams}`
    } else {
      url = `${url}${selectedData}`
    }

    return url
  }, '')
}

export default ({ currentSite }: { currentSite: Site }) => {
  return (
    <div className="cross-sell">
      <div className="grid-container">
        <ul className="cross-sell__list">
          {crossSellLinksLayoutConfig.map(crossSellLink => {
            return (
              <li key={crossSellLink.key} className="cross-sell__list-item">
                <a
                  href={urlFor(crossSellLink.url, currentSite)}
                  className="cross-sell__link"
                >
                  <figure>
                    <picture>
                      <source media="(max-width: 480px)" srcSet="" />
                      <EnhancedLazyLoad
                        height="100%"
                        once
                        offset={ui.lazyLoadOffset}
                      >
                        <img
                          src={imageSrc(crossSellLink.imageSrc)}
                          className="cross-sell__image"
                          alt={crossSellLink.label}
                          srcSet={imageSrcSet(crossSellLink.imageSrcSet)}
                        />
                      </EnhancedLazyLoad>
                    </picture>

                    <figcaption className="cross-sell__text-container">
                      <SafeInnerHtml
                        Tag="p"
                        html={crossSellLink.heading}
                        className="fds-c-text-body -color-inherit -size-l -weight-bold h-mb1"
                      />
                      <p className="fds-c-text-body -color-inherit -size-m h-m0">
                        <small className="cross-sell__text">
                          {crossSellLink.subHeading}
                        </small>
                      </p>
                    </figcaption>
                  </figure>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
